export class SelectItems extends Array<{ key: string, value: string }> {
    static readonly BEFUND_VERGLEICHSOPERATOREN: SelectItems = [
        { key: '1', value: '>' },
        { key: '2', value: '=' }, 
        { key: '3', value: '<' },
        { key: '4', value: '>=' },
        { key: '5', value: '<=' }
    ];
}
